import React from 'react'

const Body = () => {
    return (
        <section id="features" className="section">
		    <div className="container">
                <div className="row">
                    <div className="col-md-12 headline text-center">
                        <h2><strong>¿Qué es Cadem Online?</strong></h2>
                        <h4 style={{ fontWeight : 'normal'}}>
                            Cadem Online es una comunidad que reúne a personas en todo Chile, quienes entregan su
                            opinión contestando nuestras encuestas. Por cada encuesta que respondas, participas en el
                            sorteo de interesantes premios: gift cards, smartphones, Smart TV, y muchos más. 
                        </h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="feature-box">
                            <img src="assets/images/registrate.png" alt="Logo registrate" className="img-mb-5" />
                            <h4>Regístrate</h4>
                            <p className="text-sub">
                                Completa el formulario con todos tus datos personales y serás parte
                                de nuestra comunidad. El registro es fundamental para participar en el
                                sorteo y si no lo completas correctamente no estarás participando.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="feature-box">
                            <img src="assets/images/contesta.png" alt="Logo Contesta" className="img-mb-5" />
                            <h4>Contesta encuestas</h4>
                            <p className="text-sub">
                                Recibirás encuestas que llegarán directamente a tu correo y podrás
                                contestarlas donde quieras. Mientras más encuestas contestes
                                más oportunidades tienes de ganar fabulosos premios.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="feature-box">
                            <img src="assets/images/unete.png" alt="Logo Unete" className="img-mb-5" />
                            <h4>Únete a nuestra comunidad</h4>
                            <p className="text-sub">
                                Mantente alerta a nuestras redes sociales y a tu correo para conocer las 
                                encuestas. Invita a tus amigos y familiares para que también participen
                                por increíbles premios.
                            </p>
                        </div>
                    </div>
                </div>
		    </div>
	    </section>
    )
}

export default Body;
